import { BASE_URL } from '../../../../../utils/config.base-url'

export const CAR_TYPE_PREFIX_URL = '/car-type'
export const URL_ENDPOINT_CAR_TYPE = `${BASE_URL}/car-type`
